<template>
  <div>
    <p class="text-primary text-bold text-xs space-b-half">
      <span class="mr-2">
        {{ event.date | formatDateWeekDay }}
      </span>
      <span>
        {{ event.start_time | formatTime }}
        {{ event.termination_time ? '-' : '' }}
        {{ event.termination_time | formatTime }}
      </span>
    </p>
    <p v-html="event.subject" />
  </div>
</template>

<script>
import { formatDateWeekDay } from '@/filters/format-date'
import formatTime from '@/filters/format-time'

export default {
  props: {
    event: {
      type: Object,
      required: true,
    },
  },

  filters: {
    formatDateWeekDay,
    formatTime,
  },
}
</script>
